import { render } from "./Game.vue?vue&type=template&id=5aa0bb1a"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=5aa0bb1a&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\碎梦者\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__